// Areas for the Wanted board (/wanted/<slug>). Same slugs as the Facebook
// area short links in vercel.json. Matched by postcode range — approximate,
// easy to edit: add or change ranges [from, to] (both included).
export const AREAS = {
  surfcoast: { name: 'Surf Coast', ranges: [[3216, 3217], [3228, 3232]] },
  geelong: { name: 'Geelong', ranges: [[3211, 3227]] },
  melbourne: { name: 'Melbourne', ranges: [[3000, 3210], [3335, 3340], [3427, 3442], [3750, 3810], [3910, 3944], [3975, 3978]] },
  peninsula: { name: 'Mornington Peninsula', ranges: [[3910, 3944]] },
  gippsland: { name: 'Gippsland', ranges: [[3815, 3909], [3950, 3974], [3979, 3996]] },
  ballarat: { name: 'Ballarat', ranges: [[3350, 3364]] },
  bendigo: { name: 'Bendigo', ranges: [[3550, 3559]] },
  vic: { name: 'Victoria', ranges: [[3000, 3999], [8000, 8999]] },
  sunshinecoast: { name: 'Sunshine Coast', ranges: [[4550, 4575]] },
  brisbane: { name: 'Brisbane', ranges: [[4000, 4199], [4500, 4521]] },
  logan: { name: 'Logan', ranges: [[4114, 4133], [4205, 4207], [4280, 4285]] },
  goldcoast: { name: 'Gold Coast', ranges: [[4208, 4230]] },
  townsville: { name: 'Townsville', ranges: [[4810, 4819]] },
  cairns: { name: 'Cairns', ranges: [[4865, 4882]] },
  qld: { name: 'Queensland', ranges: [[4000, 4999], [9000, 9999]] },
  sydney: { name: 'Sydney', ranges: [[2000, 2249], [2555, 2574], [2740, 2786]] },
  centralcoast: { name: 'Central Coast', ranges: [[2250, 2263]] },
  hunter: { name: 'Hunter', ranges: [[2280, 2340]] },
  northernrivers: { name: 'Northern Rivers', ranges: [[2460, 2490]] },
  nsw: { name: 'New South Wales', ranges: [[1000, 2599], [2619, 2899], [2921, 2999]] },
  canberra: { name: 'Canberra', ranges: [[200, 299], [2600, 2618], [2900, 2920]] },
  adelaide: { name: 'Adelaide', ranges: [[5000, 5199]] },
  perth: { name: 'Perth', ranges: [[6000, 6199]] },
  tasmania: { name: 'Tasmania', ranges: [[7000, 7999]] },
}

export const areaFor = (slug) => AREAS[(slug || '').toLowerCase()] || null

export function inArea(slug, postcode) {
  const area = areaFor(slug)
  const pc = parseInt(postcode, 10)
  if (!area || !Number.isFinite(pc)) return false
  return area.ranges.some(([from, to]) => pc >= from && pc <= to)
}

// Australian postcode → state (same rules as the database's au_state_from_postcode)
export function stateFromPostcode(postcode) {
  const p = parseInt(postcode, 10)
  if (!/^\d{4}$/.test(String(postcode || '')) || !Number.isFinite(p)) return null
  if ((p >= 200 && p <= 299) || (p >= 2600 && p <= 2618) || (p >= 2900 && p <= 2920)) return 'ACT'
  if (p >= 800 && p <= 999) return 'NT'
  if (p >= 1000 && p <= 2999) return 'NSW'
  if ((p >= 3000 && p <= 3999) || (p >= 8000 && p <= 8999)) return 'VIC'
  if ((p >= 4000 && p <= 4999) || (p >= 9000 && p <= 9999)) return 'QLD'
  if (p >= 5000 && p <= 5999) return 'SA'
  if (p >= 6000 && p <= 6999) return 'WA'
  if (p >= 7000 && p <= 7999) return 'TAS'
  return null
}
